export default __webpack_public_path__ + "static/media/dash.9e8566a4.svg";